import React from 'react';

import { BrowserRouter as Router } from 'react-router-dom';

import RfpErrorBoundary from '@components/common/RfpErrorBoundary';
import RenderRoute from '@routes/RenderRoute';

function App() {
  return (
    <RfpErrorBoundary>
      <Router>
        <RenderRoute />
      </Router>
    </RfpErrorBoundary>
  );
}

export default App;
